import { FC, memo } from "react"
import Imagen from "next/image"
import cn from "classnames"

type ImageComponentData = {
  alt: string;
  src?: string;
  classNames?: string;
  classNamesImg?: string;
};

const Image: FC<ImageComponentData> = memo(({ alt, src, classNames, classNamesImg }: ImageComponentData) => {
  return <div className={cn("relative", classNames)}>
    {
      !!src
        ? <Imagen priority className={cn("select-none", classNamesImg)} src={src} alt={alt || ""} fill 
        style={{ objectFit: "cover" }}  /> 
        : <div className={cn("bg-gray-600", classNamesImg)} />
    }
  </div>
});
Image.displayName = "Image"

export default Image